/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import WyAnalyticsContactReasonsPage from '../components/analytics/wy-analytics-contact-reasons-page.vue'
import WyAnalyticsCompareMetrics from '../components/analytics/wy-analytics-compare-metrics.vue'
import WyAnalyticsMetrics from '../components/analytics/wy-analytics-metrics-page.vue'
import WyAnalyticsModelStats from '../components/analytics/wy-analytics-model-stats-page.vue'
import WyAnalyticsTranscriptSearch from '../components/analytics/wy-analytics-transcript-search.vue'

export default [
  {
    path: '/analytics/contactReasonsPage',
    name: 'contactReasonsPage',
    component: WyAnalyticsContactReasonsPage,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      // hide avgHandlingTime and Highest volume topics by OC-1466
      // filterNames: ['date', 'custTypes', 'sources', 'languages', 'agentQueues', 'agentIds', 'agentGroups', 'devices', 'avgHandlingTime', 'maxTopics'],
      filterNames: ['date', 'custTypes', 'sources', 'languages', 'agentQueues', 'agentIds', 'agentGroups', 'devices', 'maxTopics'],
      headerMenuItems: [
        //{name:'date-widget', properties:{defaultDateStart: new Date(2020, 7, 1), defaultDateEnd: new Date(2020, 7, 30)},},
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/analytics/compareMetrics',
    name: 'compareMetrics',
    component: WyAnalyticsCompareMetrics,
    props: true,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['custTypes', 'sources', 'languages', 'agentQueues', 'agentIds', 'agentGroups', 'devices', 'maxTopics'],
      headerMenuItems: [
        {name:'date-widget', properties:{hidden: true, disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/analytics/metrics',
    name: 'metrics',
    component: WyAnalyticsMetrics,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'custTypes', 'sources', 'languages', 'agentQueues', 'agentIds', 'agentGroups', 'devices'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/analytics/modelStats',
    name: 'modelStats',
    component: WyAnalyticsModelStats,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'custTypes', 'sources', 'languages', 'agentQueues', 'agentIds', 'agentGroups', 'devices', 'businessHoursType'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/analytics/transcriptSearch',
    name: 'transcriptSearch',
    component: WyAnalyticsTranscriptSearch,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'custTypes', 'sources', 'languages', 'agentQueues', 'agentIds', 'agentGroups', 'devices'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  }
]